import React from 'react';
import PropTypes from 'prop-types';
import Button from './CustomButton'
import { faSyncAlt } from '@fortawesome/fontawesome-free-solid'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

const propTypes = {
  label: PropTypes.string.isRequired,
  onTryAgain: PropTypes.func.isRequired
};


const TryAgain = ({ label, onTryAgain }) => {
  return (
    <div>
      <label>{label}</label><br />
      <Button color='danger' onClick={onTryAgain}>Try Again <FontAwesomeIcon icon={faSyncAlt} /></Button>
    </div>
  );
};


TryAgain.propTypes = propTypes;


export default TryAgain;
